<template>
  <div class="box">
    <HTTPresponse :alert="httpalert" @changeHTTPBoxState="HTTPState"></HTTPresponse>
    <v-layout
      d-block
      d-md-flex
      row
      ma-0
      align-center
      justify-space-between
      class="box-header"
    >
      <h3>{{ $t("audit-questions-box.title") }}</h3>
    </v-layout>

    <div class="box-content d-block">
      <template v-if="questions.private || questions.pending">
        <!-- Private -->
        <v-row
          v-for="(question, index) in questions.private"
          :key="`private-${index}`"
          class="d-flex px-6 px-md-3"
        >
          <v-flex
            ma-0
            xs9
            justify-start
            class="d-flex mb-6"
          >
            <small v-if="question.question">{{question.question}}</small>
          </v-flex>
          <v-flex
            ma-0
            xs3
            justify-end
            align-self-center
            class="d-flex mb-6"
          >
            <small class="status info ml-5">done</small>
          </v-flex>
        </v-row>
        <!-- Pending -->
        <v-row
          v-for="(question, index) in questions.pending"
          :key="`pending-${index}`"
          class="d-flex px-6 px-md-3"
        >
          <v-flex
            ma-0
            xs9
            justify-start
            class="d-flex mb-6"
          >
            <small v-if="question.question">{{question.question}}</small>
          </v-flex>
          <v-flex
            ma-0
            xs3
            justify-end
            align-self-center
            class="d-flex mb-6"
          >
            <small class="status warning ml-5">{{ $t("basic-message.tags.waiting") }}</small>
          </v-flex>
        </v-row>
      </template>

      <template v-else>
        <v-layout
          d-block
          d-md-flex
          row
          ma-0
          align-center
          justify-space-between
          class="mb-6"
        >
          <v-flex xs12>
            <h3 class="text-center">{{ $t("audit-questions-box.no-question") }}</h3>
          </v-flex>
        </v-layout>
      </template>

      <v-flex xs12 v-if="questions">
        <div class="text-center pt-3">
          <v-btn
            outlined
            rounded
            color="primary"
            class="fetch"
            to="/questions">
            {{ $t("audit-questions-box.cta") }}
          </v-btn>
        </div>
      </v-flex>
    </div>
  </div>
</template>

<script>
import { getQuestions } from '@/js/questions/getQuestions'
import HTTPresponse from '@/components/app/HTTPresponse'

export default {
  props: {
    keywords: String,
    sequences: Array | Object
  },
  components: {
    HTTPresponse: HTTPresponse
  },

  data () {
    return {
      questions: {
        private: [],
        pending: []
      },
      httpalert: false
    }
  },

  mounted () {
    this.$root.$on('disableInterceptor')
  },

  async created () {
    // if (this.$store.getters['auth/isAuthenticated!']) return

    const params = {
      keywords: this.keywords,
      key: this.$store.state.auth.token,
      questionType: 'all'
    }

    await getQuestions(params)
      .then(response => {
        if (response.private.length > 0) {
          for (var p = 0, len = response.private.length; p < len; p++) {
            this.questions.private.push(response.private[p])
          }
        }
        if (response.pending.length > 0) {
          for (var pe = 0, len = response.pending.length; pe < len; pe++) {
            this.questions.pending.push(response.pending[pe])
          }
        }
        this.$root.$on('enableInterceptor')
      })
      .catch(() => {
        this.httpalert = true
        setTimeout(() => {
          this.httpalert = false
        }, 4000)
        this.$root.$on('enableInterceptor')
      })
  },

  methods: {
    HTTPState (value) {
      this.httpalert = this.value
    }
  }
}
</script>
